import { useProfileModalV3 } from "@circle-react/components/ProfileModalV3";

export const useProfileDrawer = useProfileModalV3;
